import { render } from "./AddTariffComponent.vue?vue&type=template&id=0e62d324&scoped=true"
import script from "./AddTariffComponent.vue?vue&type=script&lang=js"
export * from "./AddTariffComponent.vue?vue&type=script&lang=js"

import "./AddTariffComponent.vue?vue&type=style&index=0&id=0e62d324&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e62d324"]])

export default __exports__